import { useRecoilValue, type RecoilState } from 'recoil'
import { dialogFamily, type IDialogState } from '../useDialog/helpers/dialogFamily/dialogFamily'

export type TDialogStateHookReturn<T> = [IDialogState<T>['open'], IDialogState<T>['data']]

/** Returns open/closed value and dialog state */
export const useDialogState = <T>(id: string): TDialogStateHookReturn<T> => {
  const { open, data } = useRecoilValue<IDialogState<T>>(dialogFamily(id) as RecoilState<IDialogState<T>>)

  return [open, data]
}
